import SearchApi from 'js-worker-search';
import utils from './utils.js';

const finder = {};
'hdipcstm'.split('').forEach((type) => {
  finder[type] = new SearchApi();
});

const _index = (type, id, text) => {
  if (text) {
    finder[type].indexDocument(id, text);
  }
};

const index = (doc) => {
  const t = doc._id[0];
  if (doc.medias && doc.medias[0]) {
    doc.medias.forEach((media, ind) => {
      const mediaText = media.comment ? `${media.name} ${media.comment}` : media.name;
      _index('m', `${doc._id}#mn${ind}`, mediaText);
    });
  }
  switch (t) {
    case 'h': // hospital
      _index('h', `${doc._id}#abb`, doc.abbr);
      _index('h', `${doc._id}#add`, doc.address);
      _index('h', `${doc._id}#cit`, doc.city);
      _index('h', `${doc._id}#com`, doc.comment);
      _index('h', `${doc._id}#ful`, doc.fullName);
      _index('t', `${doc._id}#tel`, utils.searchTel(doc.telephones));
      break;
    case 'd': // division
      _index('d', `${doc._id}#abb`, doc.abbr);
      _index('d', `${doc._id}#add`, doc.address);
      _index('d', `${doc._id}#com`, doc.comment);
      _index('d', `${doc._id}#ful`, doc.fullName);
      _index('t', `${doc._id}#tel`, utils.searchTel(doc.telephones));
      break;
    case 'i': // instrument
      _index('i', `${doc._id}#nam`, doc.name);
      _index('i', `${doc._id}#com`, doc.comment);
      _index('s', `${doc._id}#ser`, doc.serial);
      break;
    case 'p': // person
      _index('p', `${doc._id}#nam`, doc.name);
      _index('p', `${doc._id}#app`, doc.appointment);
      _index('p', `${doc._id}#com`, doc.comment);
      _index('t', `${doc._id}#tel`, utils.searchTel(doc.telephones));
      break;
    case 'c': // case
      _index('c', `${doc._id}#pro`, doc.problem);
      _index('c', `${doc._id}#res`, doc.result);
      doc.works.forEach((work, ind) => {
        _index('c', `${doc._id}#wt${ind}`, work.task);
        _index('c', `${doc._id}#ws${ind}`, work.short);
      });
      break;
    default:
      console.log('ERROR indexDocument', doc);
  }
};

const search = (type, term) =>
  new Promise((resolve, reject) => {
    finder[type].search(term)
      .then((r) => {
        if (r.length === 0) {
          resolve(r);
        } else {
          r.sort();
          const res = [{ id: r[0].split('#')[0], fields: [r[0].split('#')[1]] }];
          for (let i = 1; i < r.length; i += 1) {
            const id = r[i].split('#')[0];
            const field = r[i].split('#')[1];
            if (id === res[res.length - 1].id) {
              res[res.length - 1].fields.push(field);
            } else {
              res.push({ id, fields: [field] });
            }
          }
          console.log('result *******************', res);
          resolve(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });

export { index, search };



// WEBPACK FOOTER //
// ./src/others/search.js